import { Heading } from "almanac-ui/Heading/Heading"

import Styles from './Images.module.scss'
import { Text } from "blaze-ui/Text/Text"
import { useState } from "react"
import { useUnsplashImages } from "components/Wizards/SelectImages/ImagesProvider"
import { UploadButton } from "../../BrandKitImages/UploadButton"
import { ImagePreview } from "./ImagePreview"
import { AlmanacFile } from "types"

interface ImagesProps {
  selectedUrls: string[]
  onToggleImage: (url: string) => void
  brandKitId: number
}

export const Images = ({ selectedUrls, onToggleImage, brandKitId }: ImagesProps) => {
  const { photos, isLoading: isLoadingImages } = useUnsplashImages()
  const [newFiles, setNewFiles] = useState<AlmanacFile[]>([])

  const onSuccess = (files?: AlmanacFile[]) => {
    setNewFiles((prev) => [...prev, ...(files || [])])
  }

  return (
    <div className={Styles.imagesContainer}>
      <div className={Styles.imagesHeader}>
        <Heading level={4}>Pick a few or upload images that represent your brand</Heading>
        <Text variant="metadata" color="var(--dark-60)">
          We pulled these images we thought you'd like from stock libraries.
        </Text>
      </div>
      <div className={Styles.images}>
        <UploadButton brandKitId={brandKitId} onSuccess={onSuccess} className={Styles.uploadButtonContainer} />
        {Array.from({ length: 6 }).map((_, index) => {
          return (
            <ImagePreview
              key={index}
              url={photos[index]?.urls.small || ''}
              alt={photos[index]?.alt_description || undefined}
              isLoading={isLoadingImages}
              isSelected={selectedUrls.includes(photos[index]?.urls?.small || '')}
              onSelect={() => onToggleImage(photos[index]?.urls?.small || '')}
            />
          )
        })}
        {newFiles.map((image) => {
          return (
            <ImagePreview
              key={image.id}
              url={image.thumbnail_url || image.source_url || ''}
              alt={image.title || undefined}
              isLoading={isLoadingImages}
              isDisabled
              isSelected
            />
          )
        })}
      </div>
    </div>
  )
}
